module.exports = {
    //通用
    x_mh: "：",
    x_fh: "；",
    sys_name: 'Edu Connect後臺管理系統',
    sys_code: '© Edu Connect版權所有',
    pwd_login: '賬號登錄',
    input_code: "請填寫賬號",
    input_pwd: "請填寫密碼",
    btn_submit: '登錄',
    reset_pwd: '重置密碼',
    abt_me: '關於我們',
    flsm: '法律聲明及隱私政策',
    call_me: '聯系我們',
    sys_sn: '粵ICP備12345678號',
    about_link: 'https://www.baidu.com/',
    flsm_link: 'https://www.baidu.com/',
    call_me_link: 'https://www.baidu.com/',
    hezuo1_link: 'https://www.baidu.com/',
    hezuo2_link: 'https://www.baidu.cn/',
    hezuo3_link: 'https://www.baidu.cn/',
    wxm_cname: '小程序',
    op_ok: '操作成功',
    op_err: '操作失敗',
    tips: '提示',
    warning: '警告',
    cancel: '取消',
    rfs: '刷新',
    select_role: '請選擇角色',
    wellcom_wx: "歡迎使用Edu Connect產品",
    unknown: '未知',
    pwd_err: "兩次密碼輸入不一致",
    exit: '退出',
    new_password: '新密碼',
    fix_password: '確認密碼',
    save: "確認保存",
    coll_dir: '收藏夾',
    coll_add: '添加到收藏夾',
    coll_un: '暫無收藏記錄',
    coll_func_err: '未找到需要收藏的頁面',
    no_role: "您的賬號無權限訪問，請聯系管理員",
    http_overtime: "本次操作由於網絡超時失敗,請稍後重試",
    server_error: "服務器連接失敗",
    add_sub: '添加下級',
    info: '詳情',
    cname: '名稱',
    code: '編碼',
    web_url: "網址",
    sort: '排序',
    icon: "圖標",
    icon_color: "圖標顏色",
    system_group: '系統組',
    cat_id: '分類',
    cdesc: '描述',
    cname_tw: '繁體名稱',
    cdesc_tw: '繁體描述',
    cname_en: '英文名稱',
    cdesc_en: '英文描述',
    input: '請輸入正確內容',
    select: '請選擇',
    root: "根",
    upd: '修改',
    mod_title: '功能模板',
    add: '新增',
    org_level: "組織級別",
    mod_cname: "模版名稱",
    mod_cdesc: "模版描述",
    all: '全部',
    set_role: '配置角色',
    op: '操作',
    search_content: '搜索內容',
    prev: '上一頁',
    next: '下一頁',
    one_page: '一頁',
    one_page_line: '條',
    add_role: '添加角色',
    select_func: "請選擇功能",
    search_nodata: '查詢完畢，沒有找到對應的數據',
    incomplete: '您填寫的資料不完整',
    clean_cache: "清理通用緩存",
    clean_label: "清理",
    cache_manage: "緩存管理",
    today: '今天',
    yesterday: '昨天',
    last_days_3: '近3天',
    last_days_7: '近7天',
    last_days_30: '近30天',
    last_days_90: '近90天',
    curr_week: "本周",
    before_week: "上周",
    curr_month: "本月",
    before_month: "上一月",
    before_month3: "近3月",
    before_month4: "近4月",
    after_month: "下一月",
    curr_year: "本年",
    before_year: "上年",
    custom: "自定義",
    fm_date: '賬期',
    rw_user: '做實人',
    rw_time: '做實時間',
    week1: '周一',
    week2: '周二',
    week3: '周三',
    week4: '周四',
    week5: '周五',
    week6: '周六',
    week0: '周日',
    weeks: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
    x_dd: " =",
    x_yd: " ≈",
    x_xy: " <",
    list: '查詢',
    export: '導出',
    insert_user: '添加用戶',
    add_user: '創建用戶',
    add_time: '創建日期',
    upd_user: '修改用戶',
    upd_time: '修改時間',
    add_mod: '新增模板',
    upd_mod: '修改模板',
    set_mod_role: '配置模板角色',
    set_mod_role_func: '配置模板角色的功能',
    org_cid: "營業執照號碼",
    org_cor: "公司負責人",
    org_mobile: "聯系電話",
    cu_cname: "客服負責人",
    cu_mobile: "客服電話",
    admin_code: "平臺內部管理員",
    cid_img_lnk: "營業執照照片",
    org_cdesc: "平臺描述",
    org_location: "地區",
    status: '狀態',
    org_addr: "詳細地址",
    configure: "配置功能",
    del: "刪除",
    confirm_delete: "確認刪除嗎？",
    role_cname: "角色名稱",
    set_add: '配置',
    org_grade: '組織等級',
    org_contact: '聯系人',
    cu_ser_time: '服務時間',
    build_img_lnk: '建築圖',
    logo_img_lnk: "logo 圖片",
    org_cname: '門店名稱',
    addrvalue: '地區選擇',
    unit: '單位',
    price_unit: '元',
    f_unit: '分',
    z_unit: '張',
    hc_amt: '換卡費用',
    jb_show_diff: '交班時顯示應收',
    order_remark1: '商品銷售規則',
    order_remark2: '禮品兌換規則',
    day: '天',
    dep: '部門',
    dep_cname: "部門名稱",
    remove: "移出",
    user_code: "用戶賬號",
    user_cname: "用戶姓名",
    input_user: '請先查詢用戶',
    op_date: '操作日期',
    func_desc: '功能',
    add_user_code: '用戶編碼',
    org_code: '組織編碼',
    org_name: '組織名稱',
    use_role_cname: '使用角色',
    func_cdesc: '執行功能',
    select_org: '選擇店鋪',
    add_dep: '新增部門',
    img_lnk: "圖片",
    scroll_mouse: '鼠標上下滾動可放大縮小',
    crop_pic: "裁剪",
    org_self: "本組織",
    add_role2: "新增角色",
    add_role_user: "添加已註冊用戶",
    order_auth_flag: '可下單授權',
    role_ts: '如果選擇角色分類，當前角色總店可統一管理, 如果不選擇角色分類，屬組織內部私有, 總店無法統一管理。',
    role: '角色',
    role_cat: '角色分類',
    add_user_cname: '用戶姓名',
    code_name: '編碼 名稱',
    add_sub_role: '添加下級角色',
    org: '組織',
    add_new_user: '新增用戶',
    upd_new_user: '修改用戶',
    down_role: '下級角色',
    birth: '生日',
    setup: '配置',
    sex: '性別',
    user_pwd: '密 碼',
    cid_code: "身份證號",
    auth_code: '授權碼',
    remove_self: '移出本組織',
    remove_org_all: '移出本組織及下級',
    confirm_remove: '確認移出嗎？',
    org_prov: "省",
    org_city: "市",
    org_area: "區",
    org_addr_code: "地區編碼",
    close: '關閉',
    no_pwd: "您的新密碼和確認密碼不一致",
    org_from1_cname: '總店名稱',
    org_from2_cname: '區域名稱',
    from2_yue_xd: '區域余額',
    yfee_xd: '有效天數',
    di_label: "的",
    org_down: '下級組織',
    choosePic: '選擇圖片',
    start_date: '開業時間',
    lng: '經度',
    lat: '緯度',
    curr_org: "當前組織",
    org_add_msg: '確定用當前語言添加下級組織嗎',
    msg_mb: '短信模板',
    highset: '高級配置',
    show_day_qty: '收銀機訂單顯示',
    select_lang: '選擇語言',
    start_use: '啟用',
    msg_mod_id: '模板ID',
    msg_sign: '簽名',
    auto_send: '自動發送',
    hand_send: '手動發送',
    send_sm_from2: '通知區域會員',
    send_sm_fr: '通知門店會員',
    all_send_sm: '通知全部會員',
    un_start: '未開啟',
    sen_txt: '發送',
    mod_content: '模板內容',
    param_qty: '參數數量',
    mod_content_place: '例：[sign]親愛的大朋友們、小朋友們，明天就是我們的傳統節日了，${p1}全體工作人員祝您${p2}快樂,萬事順意。',
    max_length_20: '限20個字符',
    send_msg: '發送短信通知',
    all_member: '所有會員',
    msg_from3: '短信通知(總店)',
    member_count: '(約{0}人)',
    check_auto_send: '查看自動發送',
    hand_msg_all: '手動通知全部',
    hand_msg_screen: '手動篩選通知',
    hand_msg_mobile: '指定手機號發送',
    limit_member_mobile: "多個手機號碼，多個用英文逗號隔開",
    count_success: "計算成功",
    confirm_send: "確定發送嗎？",
    bal: '余額',
    exp_date: "有效期至",
    delete_role: '刪除角色',
    delete_succeed: '刪除成功',
    check_msg_mb: '查看短信模板',
    cu_start_time: '例：上午09:00 - 下午18:00',
    undefined: '未定義',
    add_new_role: '新增下級角色管理',
    addrole: '添加且適應角色到同級別門店',
    saverole: '保存且適應到同級別組織',
    deleterole: '刪除且適應到同級組織',
    confirm_deleterole: '確認刪除且適應到同級組織嗎',
    confirm_saverole: '確認保存且適應到同級組織嗎',
    confirm_addrole: '確認添加且適應角色到同級別門店嗎',
    self: '私有',
    default_self: '不選擇為私有角色',
    toggle_admin: '切換{0}內部管理員',
    toggle_org_admin: '切換{0}組織管理員',
    old_org_admin: '舊內部管理員賬號',
    new_org_admin: '新內部管理員賬號',
    old_org_admin1: '舊組織管理員賬號',
    new_org_admin1: '新組織管理員賬號',
    key_setup: '秘鑰配置',
    code_cname: '編碼 姓名',
    user: '用戶',
    ex_type: '擴展類型',
    cloud_service: '雲服務',
    recharge: '充值',
    recharge_order: '充值訂單',
    money_history: '余額歷史',
    link_yfee: '年費續期',
    link_exwrap: '應用市場',
    link_msg: '購買短信包',
    org_admin_code: '組織管理員',
    link_wlsc: '物料市場',
    system_use: '平臺可用',
    org0_use: '總店可用',
    org1_use: '區域可用',
    org2_use: '門店可用',
    yes: '是',
    no: '否',
    xy_dy: '≤',
    from_yue_xd: '總店余額',
    from3_yue_xd: '門店余額',
    call_add_user: '添加人員',
    name: '姓名',
    email: '郵箱',
    money_amt: '面值',
    hand_recharge: '人工充值',
    online_recharge: '在線充值',
    sure_recharge: '確認充值',
    select_goods: '請選擇套餐',
    cf_recharge: '您確認需要充值嗎？',
    save_start: "保存且繼續添加",
    def_goodsrand: '定義商品品牌',
    def_vendor: '定義供應商',
    def_unit: '定義商品單位',
    add_def_unit: '新增商品單位',
    upd_def_unit: '修改商品單位',
    add_def_goodsrand: '新增商品品牌',
    upd_def_goodsrand: '修改商品品牌',
    add_goods_color: '新增商品顏色',
    upd_goods_color: '修改商品顏色',
    cal_type: "結算方式",
    cor_cname: "聯系人",
    phone: '手機號碼',
    addrs: "地址",
    add_def_vendor: '新增供應商',
    upd_def_vendor: '修改供應商',
    cor_name_en: "英文名",
    bs_cname: "業務員中文名",
    ac_cname: "會計中文名",
    vendor_tel: "公司電話",
    vendor_fax: "公司傳真",
    vendor_email: "公司郵箱",
    org_fr_cname: "門店名稱",
    ty: "通用",
    wx_pay: '微信支付',
    ali_pay: '支付寶支付',
    chk_read: '我已了解：充值的款項只可用於萬向雲端消費，且退款只能原路退回至付款賬號。',
    pay_ok: '已支付完成',
    wx_scan: '請使用微信掃一掃支付',
    ali_scan: '請使用支付寶掃一掃支付',
    def_banci: '定義班次',
    add_def_banci: '新增班次',
    upd_def_banci: '修改班次',
    time_fr: '開始時間',
    time_to: '結束時間',
    tom_flag: '隔日',
    upimg: '上傳圖片',
    posimgs_ts: '提示：此圖片最合適的大小為1366*768，最合適寬高比為0.56',
    view_img: '預覽圖片',
    def_dategroup: '定義日期集',
    add_def_dategroup: '新增日期集',
    upd_def_dategroup: '修改日期集',
    select_date: '日期選擇',
    please_select_date: '請選擇日期',
    date_qty: "內含天數",
    def_mtag: "定義會員標簽",
    add_def_mtag: "新增會員標簽",
    upd_def_mtag: "修改會員標簽",
    membertipscat_bolor: '標簽顏色',
    def_rk: '定義快捷原因',
    add_def_rk: '新增快捷原因',
    upd_def_rk: '修改快捷原因',
    recharges0goods: '充值套餐',
    add_recharges0goods: '新增充值套餐',
    upd_recharges0goods: '修改充值套餐',
    package_cat: '套餐分類',
    package_cname: '套餐名稱',
    package_code: '套餐編碼',
    price: '單價',
    mj: '面值',
    yfees0goods: '年費續期套餐',
    add_yfees0goods: '新增年費續期套餐',
    upd_yfees0goods: '修改年費續期套餐',
    old_price: '原價',
    new_price: '現價',
    old_amt: '原金額',
    new_amt: '現金額',
    org_grade2: '店鋪等級',
    msgs0goods: '短信包套餐',
    add_msgs0goods: '新增短信包套餐',
    upd_msgs0goods: '修改短信包套餐',
    msg_qty: '短信條數',
    exwraps0goods: '應用包套餐',
    add_exwraps0goods: '新增應用包套餐',
    upd_exwraps0goods: '修改應用包套餐',
    order_code: '訂單號',
    three_code: '第三方訂單號',
    amt: '金額',
    pay_cat: '支付方式',
    pay_status: '支付狀態',
    pay_ok_time: '支付到賬時間',
    back_status: '退款狀態',
    back_ok_time: '退款到賬時間',
    tot: '匯總',
    cancel_order: '您確定要取消當前訂單嗎',
    recharge_qty: '充值筆數',
    recv_amt: '收款金額',
    recv_cat: '收款類型',
    start_money_amt: '期初余額',
    recharge_money_amt: '充入余額',
    used_money_amt: '消費余額',
    end_money_amt: '結存余額',
    start_msg_qty: '期初短信余量',
    buy_msg_qty: '購買余量',
    used_msg_qty: '使用余量',
    end_msg_qty: '結存余量',
    rw: "做實",
    rw_true: "已做實",
    rw_false: "未做實",
    warning_rw: "您確定需要將當天賬期做實嗎",
    no_cal: '尚未計算',
    cal: '計算',
    print: '打印',
    pre_date: '前一天',
    after_date: '後一天',
    last_cal_time: '最後計算時間',
    tot_amt: '總營收',
    hand_recv_amt: '人工收款一覽',
    money_change: '余額變化一覽',
    money_type: '余額變化分類',
    obg_cname: '項目名稱',
    msg_bal: '短信余量一覽',
    sum: '合計',
    bill_history: '結賬歷史',
    auto_code: '自動編碼',
    imgs: '介紹圖',
    imgs_pl: '溫馨提示：介紹圖建議上傳寬度為800px的jpg圖片，高度不限',
    mods: '適應模板',
    products0goods: '物料套餐',
    add_products0goods: '新增物料套餐',
    upd_products0goods: '修改物料套餐',
    qty: '數量',
    yfee_day_qty: '續期天數',
    recharges_order: '充值訂單',
    overage_history: '余額歷史',
    op_order_back: '退單',
    order_time: "下單時間",
    order_user: "下單人",
    confirm_back_order: '確認退單嗎？',
    time_long: '時長',
    exwrap_cname: '應用名稱',
    product_cname: '物料名稱',
    set_org: '指定組織',
    move_type: '移動類型',
    move_amt: '移動余額',
    move_time: '移動時間',
    select_time_long: '請選擇時長',
    add_time_long: '新增時長',
    bal_day_qty: '剩余天數',
    add_yfee: '續期',
    yfee_order: '續期訂單',
    yfee_add: '確認續期',
    yfee_add_confirm: '確認續期嗎？',
    package: '套餐',
    package_name: '套餐名稱',
    pay_back_ok_time: '到賬時間',
    vendor: '供應商',
    add_posimg: '新增收銀機廣告圖',
    upd_posimg: '修改收銀機廣告圖',
    msg_add: '購買短信包',
    del_posimg: '您確定要刪除該收銀機廣告圖嗎',
    select_org_down: '選擇下級組織',
    bal_msg_qty: '短信余量',
    buy_order: '購買訂單',
    buy: '購買',
    sure_buy: '確認購買',
    sure_buy_comfirm: '確認購買嗎？',
    qi: '起',
    qk_flag: '加急',
    tf_cat: '期望物流',
    free_tips: '溫馨提示：當前物料貨到付款，不包含運費。',
    bal_pay: '余額支付',
    tfc_cname: '快遞名稱',
    tf_status: '發貨狀態',
    tf_code: '快遞單號',
    tfb: '接單',
    tfb_user: '接單人',
    tfb_time: '接單時間',
    tfc: '發貨',
    q_tfc: '確認發貨',
    tfc_user: '發貨人',
    tfc_time: '發貨時間',
    chk_tfb: '您確定要接單嗎',
    select_tfc: '選擇快遞公司',
    input_tf_code: '輸入快遞單號',
    p_upload_img: '請上傳圖片',
    p_upload_one_img: '請最少上傳一張圖片',
    type: '類型',
    ratio: '折',
    tags: '標簽',
    up: '起',
    cdesc2: '介紹',
    group: '分組',
    def_group: '定義商品分組',
    add_def_group: '新增商品分組',
    upd_def_group: '修改商品分組',
    def_dir: '定義商品目錄',
    add_dir1: '新增一級目錄',
    upd_dir1: '修改一級目錄',
    add_dir2: '新增二級目錄',
    upd_dir2: '修改二級目錄',
    goods_code_before: '貨號前綴',
    goods_code_before_err: '貨號前綴限兩位，允許輸入字母和數字，請填寫正確',
    buy_has: '已購買',
    mv_msg_qty: '移動余量',
    goods_cat2: '商品分類',
    goods_type: '商品類型',
    dir_cname_1: '一級目錄',
    dir_cname_3: '三級目錄',
    add_dir3: '添加三級目錄',
    upd_dir3: '修改三級目錄',
    price_ratio: '購買單價折扣',
    ac_ratio: '積分兌換折扣',
    ac_price: '積分兌換價',
    member_price: '會員類型定價',
    def_area: '定義門店區域',
    add_def_area: '新增門店區域',
    upd_def_area: '修改門店區域',
    dev_brand: '設備品牌',
    add_dev_brand: '新增設備品牌',
    upd_dev_brand: '修改設備品牌',
    dev_types: '設備類型',
    add_dev_types: '新增設備類型',
    upd_dev_types: '修改設備類型',
    type_code: '類型編碼',
    goods_cat: '關聯套餐',
    dev_mods: '設備機型',
    add_dev_mods: '新增設備機型',
    upd_dev_mods: '修改設備機型',
    brand: '品牌',
    dev: '設備',
    goods_spec: "型號/規格",
    people_qty: "容納人數",
    lenght: "長",
    width: "寬",
    height: "高",
    space: "占地面積",
    mod_code: "機型編號",
    mod_reader: "收費口數量",
    card_no: '卡號',
    limit_use_qty: '可使用',
    unit_ci: '次',
    bal_use: '剩余',
    add2: '添加',
    only_fr: '指定門店',
    limit_use_qty2: '每日限使用次數',
    all_dev_flag: '全店通用',
    org_ty: '門店分區通用',
    only_dev: '指定設備',
    pl_dev_codes: "指定多個設備，用英文逗號隔開",
    js_3num: '建議3位數字，起始值001',
    js_4num: '建議4位數字，起始值0001',
    max_code: '最大號碼',
    reget: '重新獲取',
    max_code_ts: '號碼以最大號碼數字加1，提示重復請重新獲取',
    not: '無',
    m_unit: '米',
    p_unit: '平方',
    base_membertype: '會員類型',
    add_base_membertype: '新增會員類型',
    upd_base_membertype: '修改會員類型',
    type_cname: '類型名稱',
    level: '等級',
    forever: '無限期',
    limit_days: '有效時間',
    buy_add_days: "購買商品自動續期(天)",
    used_ac_up: "累計消費積分升級",
    timeout_void_days: "過期多久自動回收(天)",
    limit_date: '會員到期日期',
    buy_add_days2: '購買商品自動續期',
    timeout_void_days2: "過期多久自動回收",
    dev_dev1: '終端設備',
    add_dev_dev1: '新增終端設備',
    upd_dev_dev1: '修改終端設備',
    dev_vender_sn: '序列號',
    mod: '機型',
    select_devs: "請選擇可用的設備",
    dev_ok: "有效設備",
    not_0: "0不啟用",
    date_0: "0無期限",
    not_up_0: "0不參與升級",
    num: "整數",
    obj_code: "項目",
    orgarea: '門店區域',
    stock_line: "關聯倉庫",
    copy: '復製',
    dev_only_code: "唯一碼",
    color: '顏色',
    df_lang: '默認語言',
    print_code: '雲打印機編碼',
    print_auto: '自動打印小票',
    minute: '分鐘',
    use_remark: '使用說明',
    remark: "備註",
    bar_code: '條碼',
    goods_code: '貨號',
    dir_id: '目錄',
    chk_auth: '需授權',
    goods_code2: '商品編碼',
    goods_code2_add: '新增總店自營商品',
    goods_code2_upd: '修改總店自營商品',
    goods_code2_copy: '復製總店自營商品',
    bar_code_pl: '請掃描或輸入條碼，如果是輸入請安回車',
    att_ac: '附送積分',
    po_price: '采購價',
    trade: '商標',
    join_qty_flag: '虛擬庫存',
    manu: '廠商',
    join_to: '關聯到',
    start: '期初',
    move: '移動',
    end: '結余',
    operation_user: '操作人員',
    time: '時間',
    goods: '商品',
    goods_pl: '條碼 貨號 名稱',
    base_price: '基價',
    org_price_only: '門店單獨定價',
    org_po_only: '門店單獨定采購計劃',
    com1_code: '統一單號',
    stock: '倉庫',
    sn_cname: '單據憑證',
    inv_no: '發票號碼',
    dtl: '明細',
    mv_qty: '移動數量',
    mv_price: '移動單價',
    mv_amt: '移動金額',
    snpoa: '采購入倉',
    snpoa_add: '新增采購入倉單',
    snpoa_auto_add_a: '智能生成總店自營商品采購入倉單',
    snpoa_auto_add_c: '智能生成門店自營商品采購入倉單',
    snpoa_upd: '修改采購入倉單',
    snpoa_dtl_add: '新增采購入倉單明細',
    snpoa_dtl_upd: '采購入倉單明細',
    note: '單據',
    note_date: '單據日期',
    dtl_add: '添加明細',
    dtl_insert: '插入明細',
    dev_doc_ts: '提示：優先級不能小於0，優先級值越小級別越高，填寫後保存生效',
    sort_err: '排序不能為空',
    set_goods: '配置套餐',
    to: '到',
    copy_ts: '復製的狀態為下架',
    search_goods: '搜索商品',
    search_goods_pl: '請搜索商品',
    stock_qty: '庫存數量',
    line_id: '行號',
    row: '行',
    auto_add: '自增',
    chk_del: '您確定要刪除嗎',
    rw_note: '審核',
    vd_note: '作廢',
    chk_note_rw: '您確定要審核當前單據嗎',
    chk_note_vd: '您確定要作廢當前單據嗎',
    chk_note_recv: '您確定要簽收當前單據嗎',
    pro_stock: '配置倉庫',
    stock_add: '新增倉庫',
    stock_upd: '修改倉庫',
    po_flag: '允許采購',
    po_recv_flag: '采購到貨倉',
    stock_price: '成本單價',
    stock_amt: '成本金額',
    loss_amt: '虧損金額',
    org_fr: '從組織',
    org_to: '到組織',
    stock_fr: '從倉庫',
    stock_to: '到倉庫',
    old_qty: '原數量',
    old_cost_price: '原成本單價',
    old_cost_amt: '原成本金額',
    mv_cost_price: '移動成本單價',
    mv_cost_amt: '移動成本金額',
    new_qty: '現數量',
    new_cost_price: '現成本單價',
    new_cost_amt: '現成本金額',
    old: '原始',
    new: '當前',
    stock_sn: '庫存移動',
    snpob: '采購退貨',
    snpob_add: '新增采購退貨單',
    snpob_upd: '修改采購退貨單',
    snpob_dtl_add: '新增采購退貨單明細',
    snpob_dtl_upd: '采購退貨單明細',
    snmvb: '倉庫轉出',
    snmvb_add: '新增倉庫轉出單',
    snmvb_upd: '修改倉庫轉出單',
    snmvb_dtl_add: '新增倉庫轉出單明細',
    snmvb_dtl_upd: '倉庫轉出單明細',
    snmva: '倉庫轉入',
    snmva_dtl_upd: '倉庫轉入單簽收',
    recv: '簽收',
    snmdb: '調撥出倉',
    snmdb_add: '新增調撥出倉單',
    snmdb_upd: '修改調撥出倉單',
    snmdb_dtl_add: '新增調撥出倉單明細',
    snmdb_dtl_upd: '調撥出倉單明細',
    snmda: '調撥入倉',
    snmda_dtl_upd: '調撥轉入單簽收',
    code_pingz: '編碼 憑證',
    snoh: '其它出倉',
    snoh_add: '新增其它出倉單',
    snoh_upd: '修改其它出倉單',
    snoh_dtl_add: '新增其它出倉單明細',
    snoh_dtl_upd: '其它出倉單明細',
    sncka: '倉庫盤點',
    sncka_add: '新增盤點單',
    sncka_upd: '修改盤點單',
    sncka_lock: '鎖定盤點表',
    chk_sncka_lock: '您確定要鎖定當前盤點表嗎',
    sncka_exp: '導出盤點表',
    sncka_dtl_upd: '盤點單明細',
    chk_qty: '盤點數量',
    lock_qty: '鎖定數量',
    lock_price: '鎖定單價',
    lock_amt: '鎖定金額',
    seva_ok: '已保存',
    re_seva: '重新保存',
    goods_wrap: '組合商品',
    fcolor: '文字顏色',
    bcolor: '背景顏色',
    limit_buy: '購買限製',
    limit_use: '使用限製',
    limit_time: '限時段',
    not_date_id: '排除日期集',
    buy_other_limit: '購買須知',
    buy_date_id: '可購日期集',
    buy_date_fr: '可購日期從',
    buy_date_to: '可購日期到',
    buy_limit_week: '可購星期',
    use_other_limit: '使用說明',
    rate_type: '周期',
    buy_limit_qty: '可購次數',
    date_tips: '1表示當天 2表示今天到明天23:59 ...',
    stockitem: '商品庫存',
    sub_goods_cname: '子商品名稱',
    sub_goods_ts: '提示：下架子商品不會影響已配置的子商品，如需移除已配置好的子商品請刪除',
    sub_goods_add: '添加子商品',
    sub_goods_card_pl: '實物商品',
    add_err: '請勿重復添加',
    member_price_err: '會員類型尚未定價',
    recharge_to: '續期到',
    up_to: '升級到',
    use_date_id: '可使用日期集',
    use_date_fr: '可使用日期從',
    use_date_to: '可使用日期到',
    use_qty: '可用次數',
    limit_zero: '(0表示不限)',
    min_buy_qty: '最少購買',
    use_date_week: '可使用星期',
    df_vendor: '默認供用商',
    stock_min_qty: '庫存數量低於',
    po_to_qty: '采購至數量',
    chk_auto_po: '您確定要智能生成采購單嗎',
    auto_create_note: '智能為您生成單據',
    sub_item: '子單',
    snpop: '統一采購入倉',
    snpop_add: '新增統一采購入倉單',
    snpop_auto_add: '智能生成統一采購入倉單',
    snpop_upd: '修改統一采購入倉單',
    snpop_dtl_add: '新增統一采購入倉單明細',
    snpop_dtl_upd: '統一采購入倉單明細',
    snpop_item_print: '打印統一采購入倉單',
    rw_qty: '簽收數量',
    rw_amt: '簽收金額',
    gift_qty: '贈品數量',
    no_save_data: '沒有需要保存的數據',
    diff_qty: '差異數量',
    diff_amt: '差異金額',
    ss: '實收',
    ss_qty: '實收數量',
    goods_wrap_add: '新增組合套餐',
    goods_wrap_upd: '修改組合套餐',
    goods_wrap_copy: '復製組合套餐',
    auto_count: '(自動計算)',
    po: '采購單',
    page: '頁',
    pop: '采購計劃',
    by_note: '按單據',
    by_sub_item: '按子單',
    by_org_fr: '按門店',
    by_vendor: '按供應商',
    by_dtl: '按明細',
    snmk: '商品加工',
    snmk_add: '新增商品加工單',
    snmk_upd: '修改商品加工單',
    snmk_dtl_add: '新增商品加工單明細',
    snmk_dtl_upd: '商品加工單明細',
    mk_goods: '成品',
    mk_sub_goods: '材料',
    mk_sub_goods_qty: '材料數量',
    mk_sub_add: '添加材料',
    dev_code_name: '編碼 名稱 序列號/唯一碼',
    print_qty: '打印張數',
    print_size: '打印尺寸',
    dates: '日期集',
    p_level: '優先級',
    online_status: '在線狀態',
    member_up: '升級會員等級',
    member_recharge: '續期會員有效期',
    use_day: '可用天數',
    limit_buy2: '限購',
    goods_key: '套餐密鑰',
    rate: '占比',
    set_rate: '價值平攤',
    one_buy_up: '單次滿金額升到本級',
    acc_buy_up: '累計滿金額升到本級',
    dir_exs: '規格參數',
    imgss: '圖集',
    product_imgs: '產品圖',
    product_imgs_pl: '溫馨提示：產品圖建議上傳寬高為800px*800px的jpg或png圖片',
    up_imgs_qty_err: '上傳圖片已達到數量限製',
    upload_err: "上傳失敗",
    max5z: "限5張",
    max6z: "限6張",
    set_setup: "系列配置",
    set_sub: "子系列",
    set_code: "系列號",
    set_add_self_err: '請勿將自己加入到子系列',
    set_add_err: '當前商品已經加入其他系列，不可加入到當前系列',
    set_add_err2: '當前商品未設置規格且未設置顏色，不可加入系列',
    rn: '營收性質',
    goods_info: '商品詳情',
    zhiwei: '職位',



    // init start
    zh_cname: '簡體名稱',
    tw_cname: '繁體名稱',
    en_cname: '英文名稱',
    user_zh_cname: '簡體姓名',
    user_tw_cname: '繁體姓名',
    user_en_cname: '英文姓名',
    home: {
        school: '學校',
        add_school_user: '新增學校帳戶',
        teacher: '老師',
        add_teacherl_user: '新增老師帳戶',
        school_new_apply: '學校最新申請',
        check: '查看',
        teacher_new_apply: '老師最新申請',
        school_count: '學校數量',
        teacher_count: '老師數量',
        faculty_count: '教職工數量',
        job_count: '現有的工作招聘廣告',
    },
    page_title: {
        mail_template: "郵件模板",
        Sending_mail_records: "發送的郵件記錄",
        Sending_mail_info: "發送郵件詳情",
        School_Application_Records: "學校申請記錄",
        School_profile: "學校資料修改記錄",
        School_Join_Us: "學校發佈的工作廣告",
        School_member_expire: "十四日內學校會費到期列表",
        teacher_member_expire: "七日內老師會費到期列表",
        teacher_Application_Records: "老師申請記錄",
        teacher_profile: "老師資料修改記錄",
        faculty_member_expire: "七七日內教職工會費到期列表",
        faculty_Application_Records: "教職工列表",
        faculty_profile: "教職工資料修改記錄",
        Information_platform: "平台信息分類",
        Basic_Website_Information: "網站基礎信息",
        Site_footer_Settings: "网站页脚设置",
        footer_Setting_tow: "页脚二级目录设置",
        platform_role: "平台角色设置",
        home_ad_place: "首頁廣告管理",
        history_ad_place: "歷史廣告管理",
        ad_place: "廣告位管理",
        ad_placeInfo: "廣告位明細管理",
        tags: "標籤分類管理",
        tags_item: "二級標籤管理",
        newsUpdate: "平台消息更新",
        renewal: "續費套餐管理",
        blog: "平臺教評心事管理",
        blog_ad: "教評心事廣告管理",
        cent_list: "積分列表",
        wellness_ad: "Wellness廣告管理",
        travel_ad: "Travel廣告管理",
        wellness: "平臺Wellness & Wealth管理",
        travel: "平臺Travel管理",
        white: "學校白名單管理",
        wealth_ad: "Wealth廣告管理",
        tech: "誠意推介管理",
        tech_ad: "誠意推介广告管理",
    },
    school_record: {
        id: '學校ID',
        name: '學校名稱',
        email: '郵箱',
        renewal_time: '續費日期',
        status: '狀態',
    },
    faculty: {
        id: "教職工ID",
        name: '教職工名稱',
        desc: '教職工簡介',
        avartar: '教職工頭像',
        change_profile: '教職工更改資料',
        join_time: '教職工加入時間',
        base_info: '教職工基本資料',
    },
    school: {
        recruit_title: '招聘標題',
        join_time: '學校加入時間',
        base_info: '學校基本資料',
        cn_name: '學校簡體名稱',
        tw_name: '學校繁體名稱',
        en_name: '學校英文名稱',
        login_account: '學校登入帳號',
        desc: '學校簡介',
        address: '學校地址',
        image: '學校圖片',
        news: '學校最新消息',
        recruit: '學校招聘工作',
        work_number: '工作編號',
        recruit_type: '招聘類型',
        tag: '標籤',
        job_title: '工作標題',
        job_desc: '工作簡介',
        require: '工作要求',
        entry_date: '入職日期',
        work_period: '工作週期',
        salary_range: '薪資範圍',
        salary_range2: '薪資',
        post_date: '發佈日期',
        expiry_date: '有效日期',
        change_profile: '學校更改資料',
        last_modified: '最近更改',
        change_content: '更改內容',
        published_work: '學校發佈的招聘工作',
    },
    teacher_record: {
        id: '老師ID',
        name: '老師姓名',
        alias: "別名",
        phone: "電話",
        email: '郵箱',
        renewal_time: '續費日期',
        status: '狀態',
        last_changed_time: '最後更改時間​',
        change_profile: '老師更改資料',
        join_time: '老師加入時間',
        base_info: '老師基本資料',
        educational: "教育經驗",
        workExperience: "工作經驗",
        otherInfo: "其他資料",
        year: "年份",
        subject: "學科",
        desc: '老師簡介',
        avartar: '老師頭像',
    },
    cms_email: {
        id: "郵件ID",
        title: "郵件標題",
        name: "郵件名",
        addTime: "創建時間",
        content: "內容",
        send_user: "收件人",
        int_title: "請輸入郵件標題",
        int_name: "請輸入郵件名字",
        int_content: "請輸入郵件內容",
        mail_end: '信尾',
        mail_dear: '信頭',
        org_cname: '發件人',
    },
    infoPush: {
        name: "平台消息名稱",
        content: "平台消息內容",
        cname_input: '請輸入平台消息名稱',
        content_input: '請輸入平台消息內容',
    },
    job: {
        id: "招聘廣告id",
        type: "招聘類別",
        name: "招聘職位名稱",
    },
    table: {
        search: '搜索',
        reset: '重置',
    },
    Langue: {
        zn: '中文簡體',
        tw: '中文繁體',
        en: 'English',
    },
    Info: {
        condition: "條款和細則",
        contactUs: "關於我們",
        footer_title: "頁面頁腳標題",
        order: '顯示順序',
        code: '編號',
        two_title: "二級目錄標題",
        title: "頁腳標題",
        url: "跳轉連接",
        contentInput: '請輸入條約內容',
        copyrightInput: '請輸入版權内容',
        copyright: "版權",
        user_agreement: "用戶協議",
        privacy_policy: "私隱政策",
        terms_us: "使用條款",
        homepage: "網站主頁",
        homepageInput: '請輸入網站主頁',
        homeContactUs: "聯繫我們(主頁)",
        contactUsInput: '請輸入聯繫我們內容',
        description: '網站描述',
        keywords: '網站關鍵詞',
        keywords_hint: 'keywords詞語間要用英文“,”隔開',
    },
    Role: {
        name: "平台角色名稱",
        cname_input: '請輸入平台角色名字',
    },
    Ad: {
        name: "廣告位名稱",
        name_home: "首頁廣告名稱",
        name_history: "歷史廣告名稱",
        name_info: "廣告位明細名稱",
        cname_input: '請輸入廣告位名稱',
        url_link_input: '請輸入跳轉連接',
        beginDate_input: '請輸入發佈時間',
        endDate_input: '請輸入下架時間',
        name_info_input: '請輸入廣告位明細名稱',
        name_home_input: '請輸入首頁廣告名稱',
        name_history_input: '請輸入歷史廣告名稱',
        code_input: '請輸入廣告位編碼',
        beginDate: '發佈時間',
        endDate: '下架時間',
    },
    Tags: {
        name: "標籤分類名稱",
        // names: "二級標籤名稱",
        names: "標籤名稱",
        wi: "權重"
    },
    renewal: {
        name: "續費套餐名稱",
        cname_input: "請輸入續費套餐名稱",
        price_input: '請輸入單價',
        days_input: '請輸入有效天數',
    },
    contact_name: '聯繫人',
    contact_mobile: '聯繫電話',
    detail: '詳情',
    reviewing: '待審核',
    reviewed: '已審核',
    review_overdue: '已過期',
    trans_history_record: '交易歷史記錄',
    pwd_admin: '密碼管理',
    release_status: '招聘狀態',
    look_count: '查看人數',
    deliver_count: '投遞人數',
    last_update_time: '最後更新時間',
    force_off_shelf: '強制下架',
    release: '發佈中',
    unRelease: '未發佈',
    vip_payment_plan: '會費繳費計劃',
    vip_due_time: '會費到期時間',
    off_shelf: '下架',
    confirm_off_shelf: '確定要下架嗎?',
    apply_agree: '確認申請',
    confirm_apply_agree: '確定確認申請嗎?',
    apply_reject: '拒絕申請',
    confirm_apply_reject: '確定拒絕申請嗎?',
    topic: '話題',
    modify: '修改',
    edit: '編輯',
    revert: '回滾',
    force_revert: '強制回滾',
    confirm_revert: '確認要回滚嗎?',
    text_check_res: '關鍵字檢測結果',
    new_update: '最新更改',
    abnormal: '異常',
    not_abnormal: '無異常',
    approval_refused: '審批拒絕',
    activate: '激活',
    nonactivated: '未激活',
    no_server_rw_remark: '拒絕原因不能為空',
    back: '返回',
    salary: '工資',
    company: '公司',
    upload_file_name: '上傳資料文件名',
    click_view: '點擊查看',
    payment: '繳費方式',
    publisher: '發布者',
    sure: '確認',
    improve_information: '請完善資料！',
    website_logo: "Logo",
    content: "內容",
    hotline: "熱線",
    fax: "傳真",
    sort_input: "請輸入排序順序",
    score_input: "請輸入權重",
    addressInput: '請輸入地址',
    emailInput: '請輸入郵箱',
    faxInput: '請輸入傳真',
    hotlineInput: '請輸入熱線',
    userAgreementInput: '請輸入用戶協議內容',
    privatePrivacy: '請輸入隱私策略內容',
    termsUse: '請輸入使用條款內容',
    enabled: '啟用',
    amount: '總數',
    ID: "賬號",
    PWD: "密碼",
    isJump: "是否跳轉",
    external_link: "是否外部鏈接",
    Whether_by: "是否輪播",
    title: "標題",
    brief: "簡介",
    isHome: "是否首頁",
    content_input: "請輸入內容",
    title_input: "請輸入標題",
    brief_input: "請輸入簡介",
    preserve: "保存",
    system_layout: "系統配置",
    Integral_set: "積分設置",
    Welcome_reward: "迎新獎賞",
    Credit_time: "迎新獎賞積分過期時間/天,365倍數爲按N年時間",
    Integral_transform: "N個積分轉換1元金額等值",
    PointInt: "每消費1元添加N積分",
    PresentExp: "贈送積分",
    time_fr_input: '請輸入開始時間',
    time_to_input: '請輸入結束時間',
    PresentExp_input: '請輸入贈送積分',
    effective_time_input: '請輸入積分過期時間',
    equivalent_value_input: '請輸入分轉換金額轉換',
    Integral_transform_input: '請輸入消費添加積分',
    cent: {
        time: "交易時間",
        expire_time: "過期時間",
        integral: "積分",
        employ: "積分使用／增加",
        name: "教評心事廣告名稱​",
        name_input: "請輸入教評心事廣告名稱​",
        cent_expire_time: "積分過期時間",
    },
    wellness: {
        name: "wellness廣告名稱​",
        name_input: "請輸入wellness廣告名稱​",
    },
    wealth: {
        name: "Wealth廣告名稱​",
        name_input: "請輸入Wealth廣告名稱​",
    },
    travel: {
        name: "Travel廣告名稱​",
        name_input: "請輸入Travel廣告名稱​",
    },
    alumni: '校友',
    parent: '家長',
    student: '學生',
    Details_pictures: '詳情圖片',
    photo_tip: '推薦圖片大小爲',
    and: '或',
    shop_welcome_set: '購物迎新設置',
    amount_bonus: '獎勵金額',
    member_day: '新會員註冊天數',
    Reward_ratio: '獎勵倍數',
    amount_bonus_input: '請輸入獎勵金額',
    member_day_input: '請輸入新會員註冊天數',
    Reward_ratio_input: '請輸入獎勵倍數',
    Reward_Type: '獎勵類型',
    onTop: '是否置頂',
    product_ids: '關聯商品',
    wellness_ids: '關聯健康 ',
    product_ids_input: '請輸入關聯商品Id',
    wellness_ids_input: '請輸入關聯健康Id',
    travel_ids: '關聯旅遊',
    travel_ids_input: '請輸入關聯旅遊Id',
    noMore: '沒有更多了',
    email_error: "郵箱格式不正確",
    WinmailTitle: '系統郵箱配置',
    mail_code: '郵箱類型',
    mail_user_name: '郵箱賬號',
    mail_password: '授權碼',
    mail_per_day: '1天發送總量',
    mail_per_hour: '1小時發送總量',
    mail_per_minute: '1分鐘發送總量',
    default_status: '是否默認',
    mail_code_input: '請選擇郵箱類型',
    mail_user_name_input: '請輸入郵箱賬號',
    mail_password_input: '請輸入授權碼',
    mail_per_day_input: '請輸入1天發送總量',
    mail_per_hour_input: '請輸入1小時發送總量',
    mail_per_minute_input: '請輸入1分鐘發送總量',
    multiples: '是否多選',
    concept: '本會理念',
    author: '作者',
    author_input: '請輸入作者',
    thinkTitle: '冷思熱話管理',
    think_ids: '關聯冷思熱話',
    think_ids_input: '請輸入關聯冷思熱話Id',
    video_input: '請輸入youtube視頻網址',
    videoURL: '視頻網址',
    Teaching_Staff: '教學人員',
    Non_Teaching_Staff: '非教學人員',
    static: "靜態",
    rotation: "輪播",
    detailed_page: "詳細頁",
    Copy_language: "复制到其他语言",
    NotSuitable: "不適用",
    SalaryType: "薪金類别",
    RecordData: "資料提交紀錄",
    type_input: '請選擇類型',
    techCentName: '誠意推介廣告名稱',
    techName_input: "请输入誠意推介廣告名稱​",
};



// WEBPACK FOOTER //
// ./src/utils/lang/zh-TW.js